import { render } from "./SeachItems.vue?vue&type=template&id=79285e1c"
import script from "./SeachItems.vue?vue&type=script&lang=js"
export * from "./SeachItems.vue?vue&type=script&lang=js"

import "./SeachItems.vue?vue&type=style&index=0&id=79285e1c&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__